module.exports = __webpack_public_path__ + "img/empty-group-buyings-image.f3c22bff.svg";